// extracted by mini-css-extract-plugin
export var emailInputBubbleContainer = "_on-0";